import Authenticated from "@/Layouts/Authenticated";
import { Head, Link } from "@inertiajs/inertia-react";
import { Roles, Validations } from "@/Components/Config";

const Index = ({ store, roles, ...props }) => {

    console.log(props)

    return (
        <Authenticated
            store={store}
            branchOffice={props.office}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight flex justify-between">
                <p>Configuración <span className="capitalize">{store}</span></p>
            </h2>}
        >
            <Head title={`Configuración - ${store.charAt(0).toUpperCase() + store.slice(1).toLowerCase()}`} />

            <main className="py-4 px-4">
                <Roles roles={roles} />
                <Validations roles={roles} />
            </main>
        </Authenticated>
    );
};

export default Index;
